module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Widget */
(function (fox, $) {
	"use strict";

	require('./banner')(fox);

	fox.registerWidget('Html5Player_EndBanner', {
		setBanner: function() {
			var img = this.rwom1('@parent @parent').getOption('onFinishPlayerImage') || this.rwom1('@parent @parent').getOption('onPausePlayerImage');

			if (img && !fox.site.member) {

				this.setOption('manualRender', false);
				
				this.setTemplateOptions({
					endBanner: img,
					endBannerUrl: fox.getEnv('siteProps.ubs.joinUrl') || '/join'
				});
				this.render();
			}
		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/widget/endBanner.js
// module id = 521
// module chunks = 4